import { createAction, props } from '@ngrx/store';
import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationsRequestState } from '@app/main/main-screen/store/data/correlations/correlations.state';
import { CorrelationMode } from '@app/api/enums/correlation-mode.enum';

export const loadCorrelations = createAction(
  '[Correlations] Load Correlations',
  props<{ triggerId: string; request: ICorrelationsRequestState }>()
);

export const loadCorrelationsSuccess = createAction(
  '[Correlations] Load Correlations Success',
  props<{
    triggerId: string;
    request: ICorrelationsRequestState;
    correlations: ICorrelation[];
    mode: CorrelationMode;
  }>()
);

export const getCorrelation = createAction('[Correlations] Get Correlation', props<{ correlationId: string }>());
export const getCorrelationSuccess = createAction(
  '[Correlations] Get Correlation Success',
  props<{
    correlation: ICorrelation;
  }>()
);

export const getCorrelationFailure = createAction(
  '[Correlations] Get Correlation Failure',
  props<{
    correlationId: string;
    error: IApiBaseErrorResponse;
  }>()
);

export const correlationsFailure = createAction(
  '[Correlations] Load Failure',
  props<{ error: IApiBaseErrorResponse }>()
);
